import {showLoaderAsync} from '../../helpers/loaders';
import {api} from '../../ApiFacade';
import {makeObservable, observable, runInAction} from 'mobx';
import {showCommunicationError} from '../../helpers/alerts';
import {LogDocument} from '../../swagger';


export class LogIntergrationViewState {
    @observable
    item?: LogDocument;

    constructor() {
        makeObservable(this);
    }

    load(logId: string) {
        showLoaderAsync(api().logs.apiLogsLogIdGet({
            logId: logId,
        })
            .then((res => {
                runInAction(() => {
                    if (res.content) {
                        this.item = res.content;
                    }
                });
            }))
            .catch(err => {
                showCommunicationError(err);
            }));
    }
}
